"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9823],{

/***/ 71813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59843);
/* harmony import */ var _mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39112);
/* harmony import */ var _mui_icons_material_Refresh__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(22748);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57077);
/* harmony import */ var _mui_material_LinearProgress__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(62471);
/* harmony import */ var _mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34756);
/* harmony import */ var _mui_material_MenuList__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37059);
/* harmony import */ var _mui_material_Paper__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(73469);
/* harmony import */ var _mui_material_Popover__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8756);
/* harmony import */ var _mui_material_Radio__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9734);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8942);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(52875);
/* harmony import */ var material_ui_popup_state_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9186);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13515);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99109);
/* harmony import */ var _contexts_timepicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80484);
/* harmony import */ var _hocs_with_clock__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83685);

























var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_4__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        container: {
            width: "80px",
            height: "40px",
            overflow: "hidden",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            padding: 0
        },
        buttonContainer: {
            display: "flex",
            width: "100%",
            height: "100%",
            flexWrap: "nowrap"
        },
        button: {
            height: "100%",
            minHeight: "0px",
            minWidth: "0px",
            width: "100%",
            borderRadius: "0px"
        },
        refreshButtonContainer: {
            width: "100%"
        },
        dropDownButton: {
            borderLeft: "1px solid rgba(0, 0, 0, 0.23)",
            height: "100%",
            minHeight: "0px",
            borderRadius: "0px",
            minWidth: "25px",
            padding: "0 0 3px 0"
        },
        dropDownArrow: {
            paddingTop: "0px"
        },
        progress: {
            marginTop: "-4px"
        },
        radio: {
            padding: "0",
            marginRight: theme.spacing(),
            "& svg": {
                width: "20px",
                height: "20px"
            }
        }
    };
});
var POLL_INTERVALS = [
    10..seconds,
    30..seconds,
    1..minutes,
    5..minutes,
    10..minutes
];
var AUTOMATIC_RELOAD_MAX_SPAN_HOURS = 48;
var _POLL_INTERVALS = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(POLL_INTERVALS, 2), defaultPollInterval = _POLL_INTERVALS[1];
var LiveDataButton = function(param) {
    var loading = param.loading, overrideStyle = param.overrideStyle, onRefresh = param.onRefresh, _pollIntervals = param.pollIntervals, pollIntervals = _pollIntervals === void 0 ? POLL_INTERVALS : _pollIntervals, _initialPollInterval = param.initialPollInterval, initialPollInterval = _initialPollInterval === void 0 ? defaultPollInterval : _initialPollInterval;
    var _Math;
    var classes = useStyles().classes;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)(), 1), t = ref[0];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .useLocalStorage */ ._)("pollInterval", initialPollInterval), 2), pollInterval = ref1[0], setPollInterval = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_contexts_timepicker__WEBPACK_IMPORTED_MODULE_7__/* .TimepickerContext */ .Ai), setTime = ref2.setTime, from = ref2.from, to = ref2.to, relativeTimeInterval = ref2.relativeTimeInterval;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_hocs_with_clock__WEBPACK_IMPORTED_MODULE_8__/* .ClockContext */ .n_), currentTime = ref3.currentTime, start = ref3.start;
    var requestedDuration = (to || currentTime).getTime() - from.getTime();
    // Disable live reloading if the requested duration is too long or the time range is in the past.
    var disableLiveReloading = AUTOMATIC_RELOAD_MAX_SPAN_HOURS < Math.floor(requestedDuration / 1..hours) || !!(to && to < currentTime);
    var lowestLiveInterval = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(pollIntervals));
    var refresh = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(newFrom, newTo) {
        setTime(newFrom, newTo);
        onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
    }, [
        from,
        to,
        onRefresh,
        setTime
    ]);
    var currentTimeMillis = currentTime.getTime();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(currentTimeMillis), baseTime = ref4[0], setBaseTime = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        return start();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (disableLiveReloading || !pollInterval || pollInterval === "manual") {
            return;
        }
        var interval = setTimeout(function() {
            // If we are in relative time mode, update from
            var newFrom = relativeTimeInterval ? new Date(Date.now() - relativeTimeInterval) : from;
            refresh(newFrom, to);
        }, Math.max(10..seconds, pollInterval));
        setBaseTime(currentTimeMillis);
        return function() {
            return clearTimeout(interval);
        };
    }, [
        from,
        pollInterval
    ]);
    var isLive = !!pollInterval;
    var terminationTime = !disableLiveReloading && pollInterval && pollInterval !== "manual" ? baseTime + pollInterval : 0;
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        if (!terminationTime) {
            return [
                0,
                0
            ];
        }
        var timeProgression = currentTimeMillis - baseTime;
        var fullTimeSpan = terminationTime - baseTime;
        var timeRemaining = terminationTime - currentTimeMillis;
        return [
            timeRemaining,
            Math.floor(timeProgression / fullTimeSpan * 100)
        ];
    }(), 2), timeRemaining = ref5[0], liveProgress = ref5[1];
    // FIXME: These translations do not relate to the button's behavior.
    var tip = timeRemaining ? t([
        "shared:waitUntilPastLowestInterval"
    ], {
        seconds: Math.max(0, Math.floor(timeRemaining / 1..seconds)),
        defaultValue: "{{seconds}} seconds before you can refresh again"
    }) : t([
        "shared:refreshRateIntervalsOf30Seconds"
    ], {
        seconds: lowestLiveInterval / 1..seconds,
        defaultValue: "Click to refresh. The refresh rate is in intervals of {{seconds}} seconds"
    });
    var tipLoading = t([
        "shared:loadingData"
    ], {
        defaultValue: "Loading data"
    });
    var popupState = (0,material_ui_popup_state_hooks__WEBPACK_IMPORTED_MODULE_10__/* .usePopupState */ .o_)({
        variant: "popover",
        popupId: "liveIntervalPicker"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        popupState.close();
    }, [
        pollInterval
    ]);
    var onRefreshClick = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var fromMillis = from.getTime();
        // Bipolar shift (-1 / 1) on each click to force fetching new data.
        var shiftedFrom = fromMillis + fromMillis % 2 * 2 - 1;
        refresh(new Date(shiftedFrom), to ? new Date(to) : to);
    }, [
        from,
        to
    ]);
    var onManualClick = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        setPollInterval("manual");
    }, []);
    var onIntervalClick = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(param) {
        var target = param.target;
        var _dataset = target.dataset, _intervalIndex = _dataset.intervalIndex, intervalIndex = _intervalIndex === void 0 ? 0 : _intervalIndex;
        var interval = pollIntervals[Number(intervalIndex)];
        setPollInterval(interval);
        setBaseTime(currentTimeMillis);
        router.push({
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, router.query), {
                refreshRate: interval
            })
        });
    }, [
        popupState
    ]);
    var menuItems = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return pollIntervals.map(function(interval, index) {
            var intervalInSeconds = interval / 1..seconds;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                disabled: disableLiveReloading,
                "data-interval-index": index,
                style: {
                    fontWeight: 300,
                    paddingTop: "5px",
                    paddingBottom: "5px"
                },
                onClick: onIntervalClick,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Radio__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        color: "primary",
                        disabled: disableLiveReloading,
                        className: classes.radio,
                        checked: !disableLiveReloading && pollInterval === interval,
                        value: "".concat(interval)
                    }),
                    intervalInSeconds > 60 ? "".concat(intervalInSeconds / 60, " ").concat(t([
                        "shared:minutes"
                    ], {
                        defaultValue: "minutes"
                    }).toLowerCase()) : "".concat(intervalInSeconds, " ").concat(t([
                        "shared:seconds"
                    ], {
                        defaultValue: "seconds"
                    }).toLowerCase())
                ]
            }, interval);
        });
    }, [
        disableLiveReloading,
        pollInterval,
        pollIntervals,
        onIntervalClick
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.container,
        style: overrideStyle,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.buttonContainer,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        title: loading ? tipLoading : tip,
                        placement: "top-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: classes.refreshButtonContainer,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                className: classes.button,
                                variant: "text",
                                color: isLive ? "primary" : undefined,
                                onClick: onRefreshClick,
                                disabled: loading,
                                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    size: 16,
                                    color: "primary",
                                    thickness: 5
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Refresh__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                        className: classes.dropDownButton,
                        variant: "text",
                        color: isLive ? "primary" : undefined
                    }, (0,material_ui_popup_state_hooks__WEBPACK_IMPORTED_MODULE_10__/* .bindToggle */ .LI)(popupState)), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                            className: classes.dropDownArrow
                        })
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Popover__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (0,material_ui_popup_state_hooks__WEBPACK_IMPORTED_MODULE_10__/* .bindPopover */ .ZW)(popupState)), {
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "right"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_MenuList__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                dense: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        disabled: true,
                                        divider: true,
                                        style: {
                                            fontWeight: 500,
                                            color: "black"
                                        },
                                        children: t([
                                            "shared:refreshInterval"
                                        ], {
                                            defaultValue: "Refresh interval"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        style: {
                                            fontWeight: 300,
                                            paddingTop: "5px",
                                            paddingBottom: "5px"
                                        },
                                        onClick: onManualClick,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Radio__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                color: "primary",
                                                className: classes.radio,
                                                checked: disableLiveReloading || !pollInterval || pollInterval === "manual",
                                                value: "manual",
                                                name: "manual"
                                            }),
                                            t([
                                                "shared:manual"
                                            ], {
                                                defaultValue: "Manual"
                                            })
                                        ]
                                    }),
                                    menuItems,
                                    disableLiveReloading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        style: {
                                            fontWeight: 300,
                                            maxWidth: "150px",
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            height: "unset",
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                            variant: "caption",
                                            style: {
                                                whiteSpace: "normal"
                                            },
                                            children: t([
                                                "shared:automaticReloadOnlyIfRelative"
                                            ], {
                                                defaultValue: "Automatic reloading is only available when selecting a relative time range up to {{hours}} hours.",
                                                hours: AUTOMATIC_RELOAD_MAX_SPAN_HOURS
                                            })
                                        })
                                    }, "explanation")
                                ]
                            })
                        })
                    }))
                ]
            }),
            terminationTime ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_LinearProgress__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                className: classes.progress,
                variant: "determinate",
                value: 100 - liveProgress
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LiveDataButton);


/***/ }),

/***/ 29876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Undo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88397);
/* harmony import */ var _mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37774);
/* harmony import */ var _mui_material_Tabs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57470);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);
/* harmony import */ var _components_buttons_scroll_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64149);
/* harmony import */ var _components_pickers_date_time_range_picker__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63917);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61431);
/* harmony import */ var _contexts_timepicker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80484);
/* harmony import */ var _helpers_helper_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15608);















var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    var _obj;
    return {
        timeSelector: {
            minWidth: 60,
            maxWidth: 60
        },
        customTimeIcon: {
            height: "16px"
        },
        selectedTimeText: {
            color: "#27aae1"
        },
        timePickerTabs: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            overflow: "hidden",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
                width: "0 !important"
            }
        }, theme.breakpoints.down("sm"), {
            marginLeft: theme.spacing(-2),
            marginRight: theme.spacing(-2)
        }),
        tabsScroller: {
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
                width: "0 !important"
            }
        },
        timePickerSelectedTime: (_obj = {
            marginLeft: "1em"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("lg"), {
            marginTop: "0.5em"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            marginTop: "1em"
        }), _obj),
        flex: {
            flex: 1,
            overflow: "hidden",
            marginTop: theme.spacing(-1)
        },
        hiddenOnMobile: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.down("sm"), {
            display: "none"
        }),
        hidden: {
            minWidth: 60,
            maxWidth: 60,
            visibility: "hidden"
        }
    };
});
var SelectedText = function(param) {
    var from = param.from, to = param.to;
    var classes = useStyles().classes;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)([
        "shared"
    ]), 2), t = ref[0], i18n = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: classes.timePickerSelectedTime,
        variant: "body2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classes.hiddenOnMobile,
                children: [
                    t([
                        "shared:selected"
                    ], {
                        defaultValue: "Selected"
                    }),
                    ": "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.selectedTimeText,
                children: (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_7__/* .timeFormatyyyyMMdhmm */ .td)(from, i18n.language)
            }),
            " ",
            t([
                "shared:to"
            ], {
                defaultValue: "to"
            }).toLowerCase(),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classes.selectedTimeText,
                children: to ? (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_7__/* .timeFormatyyyyMMdhmm */ .td)(to, i18n.language) : t([
                    "shared:now"
                ], {
                    defaultValue: "now"
                }).toLowerCase()
            })
        ]
    });
};
var TimePicker = function(param) {
    var _hideSelected = param.hideSelected, hideSelected = _hideSelected === void 0 ? false : _hideSelected, includeLargeRanges = param.includeLargeRanges;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_timepicker__WEBPACK_IMPORTED_MODULE_8__/* .TimepickerContext */ .Ai), from = ref.from, to = ref.to, setTime = ref.setTime, historySize = ref.historySize, undo = ref.undo, relativeTimeInterval = ref.relativeTimeInterval;
    var classes = useStyles().classes;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)([
        "shared"
    ]), 1), t = ref1[0];
    var calendarIconRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref2[0], setOpen = ref2[1];
    var filteredTimeSelectionIntervals = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _contexts_timepicker__WEBPACK_IMPORTED_MODULE_8__/* .timeSelectionIntervals.filter */ .PZ.filter(function(param) {
            var largeRange = param.largeRange;
            return largeRange === undefined || includeLargeRanges && largeRange === true;
        });
    }, [
        includeLargeRanges
    ]);
    var onTimeSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_, v) {
        var selectedTimeInterval = filteredTimeSelectionIntervals[Number(v)];
        if (!selectedTimeInterval) {
            return;
        }
        setTime(new Date(Date.now() - selectedTimeInterval.time), null);
    }, [
        setTime,
        filteredTimeSelectionIntervals
    ]);
    var onClickCalendarIcon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(true);
    }, [
        setOpen
    ]);
    var onClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(false);
    }, [
        setOpen
    ]);
    var onCalendarSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(start, end) {
        setTime(start, end);
        onClose();
    }, []);
    var numSelectableTabs = filteredTimeSelectionIntervals.length + 1;
    // relativeTimeInverval is not 100% exact, so +-1 second
    var value = (filteredTimeSelectionIntervals.findIndex(function(param) {
        var time = param.time;
        return relativeTimeInterval && Math.abs(relativeTimeInterval - time) < 1000;
    }) % numSelectableTabs + numSelectableTabs) % numSelectableTabs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.flex,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Tabs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                indicatorColor: "primary",
                className: classes.timePickerTabs,
                classes: {
                    scroller: classes.tabsScroller
                },
                value: value,
                onChange: onTimeSelect,
                variant: "scrollable",
                scrollButtons: true,
                ScrollButtonComponent: _components_buttons_scroll_button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
                allowScrollButtonsMobile: true,
                children: [
                    filteredTimeSelectionIntervals.map(function(param) {
                        var label = param.label;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: classes.timeSelector,
                            label: t([
                                "shared:".concat(label)
                            ], {
                                defaultValue: label
                            })
                        }, label);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        className: classes.timeSelector,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_constants__WEBPACK_IMPORTED_MODULE_12__/* .CALENDAR_PICKER_ICON */ .NR, {
                            className: classes.customTimeIcon
                        }),
                        ref: calendarIconRef,
                        onClick: onClickCalendarIcon
                    }, "custom"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tab__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        className: !!historySize ? classes.timeSelector : classes.hidden,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Undo__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.customTimeIcon
                        }),
                        onClick: undo
                    }, "time-history")
                ]
            }),
            !hideSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SelectedText, {
                from: from,
                to: to
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pickers_date_time_range_picker__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                anchorEl: calendarIconRef.current,
                disableFuture: true,
                from: from,
                to: to || new Date(),
                open: open,
                closePicker: onClose,
                setTime: onCalendarSelect,
                range: true,
                showTabs: true
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimePicker);


/***/ })

}]);